const radius = {
  smallRadius: '4px',
  normalRadius: '8px',
  mediumRadius: '16px',
  largeRadius: '24px'
};

export default radius;
